/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { SelectedPanelDataItem } from 'libs/sysque/toolbelt/feature/src/lib/models/selected-panel-data-item';

export interface ICableTraySystemFacade {
    applyPanelDataLogic(panelData: SelectedPanelDataItem, isWireFillSpec: boolean): void;
    getLocalStorage(key: string): any;
}

export const CABLE_TRAY_SYSTEM_FACADE_TOKEN = new InjectionToken<ICableTraySystemFacade>(
    'CABLE_TRAY_SYSTEM_FACADE_TOKEN'
);
